import React from 'react';
import PropTypes from 'prop-types';

class TagsRow extends React.Component {
  state = {
    editMode: false,
    deleteMode: false,
    name: this.props.name
  }

  toggleEditMode = () => {
    this.setState((prevState) => ({
      editMode: !prevState.editMode,
      deleteMode: !prevState.editMode ? false : prevState.deleteMode
    }));
  }

  toggleDeleteMode = () => {
    this.setState((prevState) => ({
      deleteMode: !prevState.deleteMode,
      editMode: !prevState.deleteMode ? false : prevState.editMode
    }));
  }

  updateName = (event) => {
    this.setState({ name: event.target.value });
  }

  renameTags = () => {
    const { updateTags, name } = this.props;
    if (this.state.name && this.state.name !== name) {
      updateTags(name, this.state.name);
    } else {
      Notify.create({
        title: t('Please enter a name.'),
        type: 'error',
      });
    }
  }

  deleteTags = () => {
    const { updateTags, name } = this.props;
    updateTags(name, null);
  }

  showTag() {
    const { count } = this.props;
    return (
      <React.Fragment>
        <div className="show-tag-mode">
          <div className="tag-information">
            { this.renderTag() }
            <div className="fifteen-width">
              <p>{t((count > 1) ? `${count}` : "1")}</p>
            </div>
          </div>
          <div className="button-container">
            <button
              className="button tertiary sm edit-tag"
              onClick={this.toggleEditMode}
              type="button"
            >
              Rename
            </button>
            <button
              className="delete-tag"
              onClick={this.toggleDeleteMode}
              onKeyUp={this.toggleDeleteMode}
              type="button"
            >
              <span className=" bff-trash" />
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderTag() {
    const { name, autoGenerated } = this.props;
    return (
      <div className="quarter-width">
        <a href={`/${BF.fx.brandfolder().slug}?q=tags.strict:"${escape(name)}"`}>
          <span className={`tag-name ${autoGenerated ? "auto-generated" : ""}`}>
            {name}
          </span>
        </a>
      </div>
    );
  }

  renderEdit() {
    const { name, count } = this.props;
    return (
      <div className="edit-tag-mode">
        <input
          id={`${name}-input`}
          type="text"
          defaultValue={name}
          onChange={this.updateName}
        />
        <div className="edit-buttons">
          <button
            className="button tertiary md cancel"
            type="button"
            onClick={this.toggleEditMode}
          >
            Cancel
          </button>
          <button
            className="button primary md"
            type="button"
            onClick={this.renameTags}
          >
            {t(`Rename ${count > 0 ? count : ""} Tag${(count > 1) ? "s" : ""}`)}
          </button>
        </div>
      </div>
    );
  }

  renderDelete() {
    const { count } = this.props;
    return (
      <div className="delete-tag-mode">
        {this.renderTag()}
        <div className="delete-buttons">
          <button
            className="button tertiary md cancel"
            type="button"
            onClick={this.toggleDeleteMode}
          >
            {t("Cancel")}
          </button>
          <button
            className="button warning md"
            type="button"
            onClick={this.deleteTags}
          >
            {t(`Delete ${count} Tag${(count > 1) ? "s" : ""}`)}
          </button>
        </div>
      </div>
    );
  }

  renderRow() {
    const { editMode, deleteMode } = this.state;
    if (editMode) { return this.renderEdit(); }
    if (deleteMode) { return this.renderDelete(); }
    return this.showTag();
  }

  render() {
    return this.renderRow();
  }
}

TagsRow.propTypes = {
  name: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  autoGenerated: PropTypes.bool.isRequired,
  updateTags: PropTypes.func.isRequired
};

export default TagsRow;
